<template lang="pug">
div
   navigation
   router-view
</template>

<script>
import Navigation from '@/components/Navigation'

export default {
  name: 'MainView',
  components: {
    Navigation
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MainView.vue